import React from "react";
import Dropdown from "../Dropdown";
import { buildAccountTypeDescriptions } from "./accountTypeDescriptions";

/**
 * PBI #299: the account type picker, with each type's customerDescription on a muted second
 * line so the orderer can see what the account type actually gives the user.
 *
 * The description of the type in use is resolved from `selectedPublicId`, never from the
 * name: two account types in one agreement may share a name, and the name is all the
 * dropdown itself knows about an option.
 */
const AccountTypeDropdown = ({
  label,
  accountTypes = [],
  selectedName = "",
  selectedPublicId = "",
  onSelect = () => {},
  placeholder,
  searchable = false,
  disabled = false,
}) => (
  <Dropdown
    label={label}
    value={selectedName || ""}
    options={(Array.isArray(accountTypes) ? accountTypes : [])
      .map((accountType) => accountType?.name)
      .filter(Boolean)}
    onSelect={onSelect}
    placeholder={placeholder}
    searchable={searchable}
    disabled={disabled}
    descriptions={buildAccountTypeDescriptions(accountTypes, selectedPublicId)}
  />
);

export default AccountTypeDropdown;
